export const colorConfig = {
    'orange': '#DB944B',
    'yellow': '#F9D978',
    'green': '#78A55A',
    'blue': '#2E65AF',
    'black': '#323232',
    'blue-dark': '#1E3554'
}
